(() => {
  const button = document.querySelector('.films-toggle');
  const extra = document.getElementById('roscoff-extra-films');
  if (!button || !extra) return;
  let motion;
  button.addEventListener('click', () => {
    const opening = button.getAttribute('aria-expanded') !== 'true';
    motion?.cancel();
    button.setAttribute('aria-expanded', String(opening));
    button.setAttribute('aria-label', opening ? 'Masquer les quatre autres vidéos' : 'Afficher quatre autres vidéos');
    if (opening) extra.hidden = false;
    else {
      extra.querySelectorAll('.roscoff-video-actions:not([hidden]) button:first-child').forEach(close => close.click());
      button.focus();
    }
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !extra.animate) {
      extra.hidden = !opening;
      return;
    }
    motion = extra.animate(
      [{opacity: opening ? 0 : 1, transform: `translateY(${opening ? '8px' : '0'})`},
       {opacity: opening ? 1 : 0, transform: `translateY(${opening ? '0' : '-8px'})`}],
      {duration: 180, easing: 'ease-out'}
    );
    motion.finished.then(() => { if (!opening) extra.hidden = true; }).catch(() => {});
  });
})();

